import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPin2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pin-2"><path d="M15.75 9.04395C17.8479 10.3143 19.25 12.6184 19.25 15.25H4.75C4.75 12.6184 6.1521 10.3143 8.25 9.04395V2.75H15.75V9.04395Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11.25 20.25V15H12.753V20.25L12 22L11.25 20.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPin2;
